import Flickity from 'flickity'
import { parseJSON } from '@/components/helpers/utils'
import debounce from 'lodash.debounce'
const defaultOptions = {
  contain: true,
  resize: false,
  imagesLoaded: true
}

// Annoying little fix for the bug where the slider doesn't resize properly with dynamically sized elements when the window is resized
const resizeListener = (flickity) => {
  const minHeightElements = flickity.slider.querySelectorAll('.min-h-full')
  minHeightElements.forEach((element) => {
    element.classList.remove('min-h-full')
  })
  flickity.resize()
  flickity.reloadCells()
  minHeightElements.forEach((element) => {
    element.classList.add('min-h-full')
  })
}

export class Carousel extends HTMLElement {
  connectedCallback() {
    const options = this.carouselOptions
    options.cellSelector = '&:not(style)'
    this.flickity = new Flickity(this, { ...defaultOptions, ...options })
    window.addEventListener('resize', this.handleResize)
  }

  observedAttributes = ['carousel-options']

  get carouselOptions() {
    const carouselOptions = this.getAttribute('carousel-options')
    if (!carouselOptions) return {}
    const parsedOptions = parseJSON(carouselOptions)
    // Handle groupCells value conversion
    if (parsedOptions?.groupCells !== undefined) {
      const value = parsedOptions.groupCells

      // Convert string 'true'/'false' to boolean
      if (value === 'true') {
        parsedOptions.groupCells = true
      } else if (value === 'false') {
        parsedOptions.groupCells = false
        // Convert numeric string to number
      } else if (!isNaN(value) && typeof value === 'string') {
        parsedOptions.groupCells = Number(value)
      }
    }
    return parsedOptions
  }

  handleResize = debounce(() => {
    if (this.flickity) {
      resizeListener(this.flickity)
    }
  }, 100)

  disconnectedCallback() {
    if (this.flickity) {
      this.flickity.destroy()
    }
  }
}
